import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, act } from '@ngrx/effects';
import {
  switchMap,
  map,
  mergeMap,
  catchError,
  exhaustMap,
  concatMap,
} from 'rxjs/operators';
import { of } from 'rxjs';

import {
  loadProducts,
  loadProductsSuccess,
  createProducts,
  updateProducts,
  deleteProducts,
  updateProductsSuccess,
  createProductsSuccess,
  deleteProductsSuccess,
  refreshProducts,
  deleteProductsError,
  updateProductsError,
  createProductsError,
} from '../actions/product.action';
import { ProductService } from '../services/product.service';

@Injectable()
export class ProductEffect {
  loadProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProducts),
      switchMap(({ pagination }) =>
        this.productService.getProducts(pagination)
      ),
      map(res => {
        return loadProductsSuccess({ ...res });
      })
    )
  );

  createProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createProducts),
      switchMap(action =>
        this.productService.createProduct(action.product).pipe(
          map(res => createProductsSuccess()),
          catchError(err =>
            of(
              createProductsError({
                error: err,
              })
            )
          )
        )
      )
    )
  );

  updateProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateProducts),
      switchMap(action =>
        this.productService.updateProduct(action.product).pipe(
          map(res => updateProductsSuccess()),
          catchError(err =>
            of(
              updateProductsError({
                error: err,
              })
            )
          )
        )
      )
    )
  );

  deleteProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteProducts),
      switchMap(action =>
        this.productService.deleteProduct(action.product).pipe(
          map(res => deleteProductsSuccess()),
          catchError(err =>
            of(
              deleteProductsError({
                error: err,
              })
            )
          )
        )
      )
    )
  );

  refreshProducts = createEffect(() =>
    this.actions$.pipe(
      ofType(refreshProducts),
      switchMap(action =>
        of(
          loadProducts({
            pagination: null,
            activePagination: action.pagination,
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private productService: ProductService
  ) {}
}
